<template>
  <div class="search-page-content">
    <div class="search-group">
      <SearchBar class="search-bar" v-model:searchBarObjects="searchBarObjects"/>
      <DxButton text="Search"
                class="search-button"
                type="action"
                @click="searchPageStore.refreshData()"
      />
    </div>
    <SearchGrid class="search-grid"/>
  </div>
</template>

<script setup>
  import { onMounted } from "vue";
  import SearchBar from "@/components/search-page/SearchBar.vue";
  import SearchGrid from "@/components/search-page/search-grid/SearchGrid.vue";
  import { DxButton } from "devextreme-vue";
  import { storeToRefs } from "pinia";
  import { useSearchPageStore } from "@/stores/searchPageStore.js";

  const searchPageStore = useSearchPageStore()
  const { searchBarObjects } = storeToRefs(searchPageStore)

  onMounted(() => {
    searchPageStore.refreshSearchPageSidebarData()
  })
</script>

<style scoped lang="scss">
  .search-page-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .search-group {
    display: flex;
    align-items: flex-start;

    margin-top: 1rem;
    padding: 0 1rem;
    gap: 20px;

    $search-tool-height: 32px;

    .search-bar {
      flex: 1 1 500px;
      min-height: $search-tool-height;
    }

    .search-button {
      flex: 0 0 80px;
      height: $search-tool-height;
    }
  }

  .search-grid {
    flex: 1 1 0;
    height: 0;
  }
</style>
